import { useLeftSidebar } from "@/components/ui/sidebar";
import { useGlobalSearch } from "@/features/search/hooks/use-global-search";
import { isMobile } from "@/lib/is-mobile";
import { fashionPaths, modelsPaths } from "@/modules";

export const useSidebarNavigation = () => {
  const { setOpen: setSidebarOpen } = useLeftSidebar();
  const { onOpenSearch } = useGlobalSearch();

  // 🔗 Link semantiği refactor: AI Models/Library/Studio/Shopping/Wardrobe artık
  // saf navigasyon — Navigation.tsx'te <Link> üstleniyor. Burada sadece mobilde
  // sidebar'ı kapatan yan etki kalıyor; hedef path'ler aşağıda tek kaynak olarak
  // export ediliyor (bkz. `*Path` alanları).
  const closeSidebarOnMobile = () => {
    if (isMobile()) {
      setSidebarOpen(false);
    }
  };

  return {
    onOpenSearch,

    // 🔗 <Link to>'nun tek kaynağı — path'ler modül registry'sinden gelir
    // (ana domainde /fashion/shop, shop.* subdomain'inde /shop).
    aiModelsPath: modelsPaths.root(),
    libraryPath: modelsPaths.library(),
    studioProjectsPath: modelsPaths.studioProjects(),
    shoppingPath: fashionPaths.shop(),
    wardrobePath: fashionPaths.wardrobe(),
    // 🆕 Harici Freshdesk yerine dahili support sayfası
    supportPath: "/support",
    onSidebarLinkClick: closeSidebarOnMobile,
  };
};
